import app from "flarum/app";
import { extend } from 'flarum/extend'
import SettingsPage from 'flarum/components/SettingsPage';
import NotificationGrid from 'flarum/components/NotificationGrid';

app.initializers.add('netcompany-mail-extender', () => {

    extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
        items.remove('postMentioned');
    });

});
